// RollUpButton.tsx
import { Tooltip } from '@mui/material';
import React from 'react';
import { MdOutlineSwipeUpAlt } from 'react-icons/md';

interface RollUpButtonProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const RollUpButton: React.FC<RollUpButtonProps> = ({ onClick }) => {
  return (<Tooltip
    title={`"Roll-Up" option helps decide the level of depth. Any dimension below Roll-Up dimension will be ignored if it is present in base dimension.`}
    placement='top'
    arrow
    slotProps={{
      tooltip: {
        sx: {
          fontSize: '12px',
        },
      },
    }}
  >
    <button
      type="button"
      className="buttonCommon columnDown"
      title="Roll-Up"
      onClick={onClick}
    >
      <span
        style={{
          display: "flex",
          alignItems: "center",
          paddingRight: "5px",
          color: "rgb(211, 211, 211)",
        }}
      >
        <MdOutlineSwipeUpAlt style={{ height: "1rem", width: "1rem" }} />
      </span>{" "}
    </button>
  </Tooltip>);
};

export default RollUpButton;
